import React from 'react';

type Level = {
  id: string;
  title: string;
  points: number;
  image: string;
  inactiveImage: string;
};

type Props = {
  points: number;
  experiencePoints: number;
  progressWidth: number;
  levelName: string;
  levels: Level[];
};

const CurrentLevel: React.FC<Props> = ({ points, levelName, levels, progressWidth, experiencePoints }) => {
  const currentIndex = levels.findIndex(l => l.title === levelName);
  const currentLevel = levels[currentIndex];
  const nextLevel = levels[currentIndex + 1];

  return (
    <div className="flex max-w-sm space-x-4">
      <img src={currentLevel.image} alt={levelName} className="w-25 h-25" />

      <div className="flex-1">
        <p className="text-black text-xl">Tu nivel actual es</p>
        <h3 className="text-xl font-bold">{levelName}</h3>
        <div className="text-holos-dark font-semibold text-lg">
          {points.toLocaleString()} HoloPoints
        </div>
        <p className="text-gray-400 text-md">
          {experiencePoints.toLocaleString()} Experience Points
        </p>

        {nextLevel && (
          <p className="text-sm text-gray-600">
            Supera los {nextLevel.points} pts para ser <em>"{nextLevel.title}"</em>
          </p>
        )}

        <div className="mt-2 w-full h-3 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-holos rounded-full transition-all duration-300"
            style={{ width: `${progressWidth}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default CurrentLevel;
